export default __webpack_public_path__ + "static/media/Aram.f8c6c72f.jpeg";